import React from 'react';
import { BookOpen, Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  const symptoms = ['Fiebre', 'Tos', 'Dolor de barriga', 'Congestión', 'Gripe', 'Resfriado'];
  return <section className="py-20 bg-sage/10" data-id="element-220">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-222">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-2 lg:order-1" data-id="element-223">
            <div className="relative" data-id="element-224">
              {/* Ebook mockup */}
              <div className="bg-white p-6 rounded-3xl shadow-xl shadow-sage/10 border border-sage/20 relative" data-id="element-225">
                <div className="absolute -left-2 top-8 bottom-8 w-1 bg-terracotta rounded-l-md" data-id="element-226"></div>

                {/* Guide cover image */}
                <div className="mb-6 rounded-2xl overflow-hidden relative" data-id="element-227">
                  <img src="https://images.unsplash.com/photo-1584515933487-779824d29309?w=600&h=300&fit=crop&crop=center" alt="Remedios naturales y hierbas para el cuidado infantil" className="w-full h-48 object-cover" data-id="element-228" />
                  <div className="absolute inset-0 bg-gradient-to-t from-forest/60 to-transparent" data-id="element-229"></div>
                  <div className="absolute bottom-3 left-4 right-4" data-id="element-230">
                    <span className="text-white font-bold text-lg drop-shadow-md" data-id="element-231">
                      PequeSalud Natural
                    </span>
                    <p className="text-white/80 text-sm drop-shadow-md" data-id="element-232">
                      Guía Digital para Madres
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-3 mb-4 border-b border-gray-100 pb-4" data-id="element-233">
                  <BookOpen className="h-6 w-6 text-terracotta" data-id="element-234" />
                  <span className="font-serif text-lg font-bold text-forest" data-id="element-235">
                    Índice Rápido
                  </span>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-236">
                  {symptoms.map((symptom, idx) => <div key={idx} className="flex items-center gap-3 p-3 rounded-lg bg-cream/50" data-id="element-237">
                      <div className="h-2 w-2 rounded-full bg-sage" data-id="element-238"></div>
                      <span className="text-forest font-medium" data-id="element-239">{symptom}</span>
                    </div>)}
                </div>

                <div className="mt-6 pt-4 border-t border-gray-100 text-center" data-id="element-240">
                  <p className="text-sm text-forest/60 italic" data-id="element-241">
                    *Formato digital PDF compatible con todos los dispositivos
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2" data-id="element-242">
            <span className="text-terracotta font-semibold tracking-wide uppercase text-sm mb-2 block" data-id="element-243">
              La Solución
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6" data-id="element-244">
              Conoce PequeSalud Natural
            </h2>
            <p className="text-lg text-forest/80 mb-6 leading-relaxed" data-id="element-245">
              Una guía digital diseñada para darte respuestas inmediatas cuando
              más las necesitas. Sin teoría innecesaria, solo lo que funciona.
            </p>

            <ul className="space-y-4 mb-8" data-id="element-246">
              <li className="flex items-start gap-3" data-id="element-247">
                <div className="bg-white p-1 rounded-full shadow-sm mt-1" data-id="element-248">
                  <Check className="h-4 w-4 text-sage-dark" data-id="element-249" />
                </div>
                <div data-id="element-250">
                  <strong className="block text-forest" data-id="element-251">
                    Acceso Inmediato
                  </strong>
                  <span className="text-forest/70" data-id="element-252">
                    Descárgala en tu celular y tenla siempre a mano.
                  </span>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-253">
                <div className="bg-white p-1 rounded-full shadow-sm mt-1" data-id="element-254">
                  <Check className="h-4 w-4 text-sage-dark" data-id="element-255" />
                </div>
                <div data-id="element-256">
                  <strong className="block text-forest" data-id="element-257">
                    Ingredientes Simples
                  </strong>
                  <span className="text-forest/70" data-id="element-258">
                    Usa lo que ya tienes en tu cocina o despensa.
                  </span>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-259">
                <div className="bg-white p-1 rounded-full shadow-sm mt-1" data-id="element-260">
                  <Check className="h-4 w-4 text-sage-dark" data-id="element-261" />
                </div>
                <div data-id="element-262">
                  <strong className="block text-forest" data-id="element-263">Consulta Rápida</strong>
                  <span className="text-forest/70" data-id="element-264">
                    Encuentra el síntoma y la solución en segundos.
                  </span>
                </div>
              </li>
            </ul>

            <div className="bg-terracotta/10 p-4 rounded-xl border border-terracotta/20" data-id="element-265">
              <p className="text-sm text-forest/90 font-medium" data-id="element-266">
                ⚠️ Importante: No reemplaza al médico. Te prepara mejor y te da
                herramientas para acompañar el proceso mientras decides qué
                hacer.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}